export const AUTHENTICATED_EMPLOYEE_JWT = "authenticatedEmployee";
export const API_HEADERS = {
  "Content-Type": "application/json",
  Authorization: `Bearer ${window.localStorage.getItem(AUTHENTICATED_EMPLOYEE_JWT)}`,
};
